/**
 * Behaviour the Capacitor app needs that a browser gets for free.
 *
 * Chrome supplied both of these while the store app was a TWA. The app has a
 * bare webview, so they have to be built. Everything here is behind
 * isNativePlatform and dynamically imported, so a browser — including an
 * installed PWA — never downloads or runs any of it.
 */
import { Capacitor } from '@capacitor/core'
import { toast } from 'react-hot-toast'
import { inAppNavigate } from './inAppNavigate'
import i18n from '../i18n'

// How long a second root-screen back press has to land after the first one
// to actually exit, instead of just showing the hint again.
const EXIT_CONFIRM_WINDOW_MS = 2000

export async function initNativeShell() {
    if (!Capacitor.isNativePlatform()) return

    const { App } = await import('@capacitor/app')

    // Root-screen back press: the first one shows a toast and buys a short
    // window, the second one (within that window) actually exits. Without
    // this, one accidental tap at the root closed the app outright.
    let lastRootBackAt = 0

    // Without this, back closes the app from any screen instead of going back.
    App.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack) {
            window.history.back()
            return
        }
        const now = Date.now()
        if (now - lastRootBackAt < EXIT_CONFIRM_WINDOW_MS) {
            App.exitApp()
            return
        }
        lastRootBackAt = now
        toast(i18n.t('pressBackAgainToExit', { ns: 'common' }), { id: 'exit-app-hint' })
    })

    // A master-splitter.com link opened from WhatsApp arrives as an event, not
    // as a page load.
    App.addListener('appUrlOpen', ({ url }) => inAppNavigate(url))
}
